import React from "react";
import Header from "../../components/Header";
import { List, Space, Image } from "antd";
import Gear from "../../assets/gear.png";
import GearReverse from "../../assets/gear-reverse.png";
import { StarOutlined, ForkOutlined } from "@ant-design/icons";
import SteinsGate from "../../assets/1606734516644.jpg";
import BotDiscord from "../../assets/botdiscord.png";
import Hoops from "../../assets/hoops_panjang(1).png";
import WeIotsWeb from "../../assets/weiotswebsite.png";
import WeIotsApps from "../../assets/weiotsapps.png";
import Wasp from "../../assets/wasp.png";
import Pju from "../../assets/pju1(1).png";
import Grintech from "../../assets/grintech2(1).png";
import Nebula from "../../assets/nebula_apps2(1).png";
import SML from "../../assets/sml2(1).png";
import Nucare from "../../assets/nucar1(1).jpg";
import ComproV2 from "../../assets/Home IKI is an IoT provider company focus on Smart Meter & Sensor IoT.png";
import KmlViewer from "../../assets/Screenshot 2024-01-02 at 21-26-50 Google Maps KML.png";
import KoboXTokped from "../../assets/Screenshot 2024-01-02 at 21-30-33 Kobo Kanaeru x Tokopedia.png";

const listData = [
  {
    href: "https://kobo-x-tokped.vercel.app/",
    title: `Kobo x Tokopedia 12.12`,
    description: "This project make using next js with tailwind css",
    content:
      "This project is just simply follow trend in Indonesia about kobo kanaeru vtuber collab with tokopedia. I make this project to fill my time in holiday.",
    star: 1,
    fork: 0,
    image: KoboXTokped,
  },
  {
    href: "https://compro-dev.we-iots.com/",
    title: `PT. IOT KREASI INDONESIA Compro v2`,
    description: "This project make using next js with tailwind css",
    content:
      "This project is and remake from the company profile before with new UI design. An IoT provider company based in Indonesia. Focusing on IoT Solution in the era of 4.0 and build an IoT platform to connect all the communication and information to achieve customer satisfaction.",
    star: 1,
    fork: 0,
    image: ComproV2,
  },

  {
    href: "https://dev-platform.nebulaiot.io",
    title: `Nebula Apps Platform`,
    description: "This project make using Umi js and Antd 4 styling library",
    content:
      "Nebula is remake from project smartmeter before with new UI, Billing System and some features. U: pancabrawijaya99@gmail.com, P: qwerty123",
    star: 1,
    fork: 0,
    image: Nebula,
  },
  {
    href: "#",
    title: `NuCare`,
    description: "This project make using react native",
    content:
      "This project used for absence and tracking pickup ziswaf in Trenggalek",
    star: 1,
    fork: 0,
    image: Nucare,
  },
  {
    href: "#",
    title: `Sml Platform`,
    description: "This project make using Umi js and Antd 4 styling library",
    content:
      "This project used for client sinarmas with specially for tracking water level",
    star: 1,
    fork: 0,
    image: SML,
  },

  {
    href: "https://gps-track.weiots.io/",
    title: `KML Viewer`,
    description: "This project make using react js and googlemaps api",
    content: "Just website to preview kml file and tracking is in area or not",
    star: 1,
    fork: 0,
    image: KmlViewer,
  },
  {
    href: "#",
    title: `Grintech Helium Minning`,
    description: "This project make using React js and Antd 4 styling library",
    content:
      "Grintech is a application to monitoring helium minning from iot device with System Affiliate Marketing",
    star: 1,
    fork: 0,
    image: Grintech,
  },
  {
    href: "https://pju.weiots.io",
    title: `PJU Smart Lightning`,
    description:
      "This project make using React js and umijs with Antd 4 styling library",
    content:
      "PJU Smartlight is an application to control and monitor a number of lights and sockets on the road.",
    star: 1,
    fork: 0,
    image: Pju,
  },
  {
    href: "https://we-iots.com/",
    title: `PT. IOT KREASI INDONESIA`,
    description: "This project make using React js with styling using less",
    content:
      "An IoT provider company based in Indonesia. Focusing on IoT Solution in the era of 4.0 and build an IoT platform to connect all the communication and information to achieve customer satisfaction.",
    star: 1,
    fork: 0,
    image: WeIotsWeb,
  },
  {
    href: "https://www.hoopsindonesia.co.id/",
    title: `HOOPS INDONESIA`,
    description: "This project make using React js and Express js.",
    content:
      "We developed this project from Trimagnus Company. That first project for me work here. This project is E-commerce to sell shoes and accessores about basketball",
    star: 1,
    fork: 0,
    image: Hoops,
  },
  {
    href: "https://github.com/brillianodhiya/-LiLiaSekai-_SteinsGate_Portofolio_Template",
    title: `Portofolio Template React js, Less, Particle Js`,
    description:
      "Free Template i've been make, inspirated by Steins Gate Anime.",
    content:
      "I created this template in to fill my free time and am being inspired with the Steins Gate anime.",
    star: 1,
    fork: 0,
    image: SteinsGate,
  },
  {
    href: "https://wasp.weiots.io/login",
    title: `WASP | Weiots SaaS Platform`,
    description:
      "This project make using React js with styling using Antd Less",
    content: "An Apps for control licenses and billing for using We Iots Apps.",
    star: 1,
    fork: 0,
    image: Wasp,
  },
  {
    href: "https://company.wiraenergi.co.id",
    title: `We Iots Web Apps`,
    description: "This project make using React js with styling using Antd",
    content:
      "An Apps for control and monitoring Iot tools with schedule or manually.",
    star: 1,
    fork: 0,
    image: WeIotsApps,
  },
  {
    href: "https://github.com/brillianodhiya/LiLiaSekaiBotDiscord",
    title: `LiLia Sekai Bot Discord`,
    description: "I've make discord bot using Discord js",
    content: "This bot discord still local with feature music and timestamp.",
    star: 1,
    fork: 0,
    image: BotDiscord,
  },
];
// for (let i = 1; i < 18; i++) {
//   listData.push({
//     href: "https://github.com/",
//     title: `Project ${i}`,
//     description:
//       "Ea incididunt laboris consectetur exercitation consequat anim eiusmod sit eu pariatur exercitation eiusmod.",
//     content:
//       "Aliqua labore dolore Lorem elit nostrud adipisicing anim veniam aliqua sit Lorem magna. Occaecat aliqua irure consectetur nisi voluptate fugiat sunt excepteur laboris exercitation. Amet minim in occaecat labore dolore pariatur exercitation proident.",
//     star: Math.floor(Math.random() * 1000) + 1,
//     fork: Math.floor(Math.random() * 1000) + 1,
//     image: `https://picsum.photos/id/${i}/272`,
//   });
// }

const IconText = ({ icon, text }) => (
  <Space>
    {React.createElement(icon)}
    {text}
  </Space>
);

const Portofolio = ({ isBreakPosition }) => {
  return (
    <div style={{ margin: "24px" }}>
      <img
        alt="gear-background"
        style={{ right: 0, position: "absolute" }}
        src={Gear}
      />
      {!isBreakPosition && (
        <img
          alt="gear-background"
          style={{ left: 50, position: "absolute" }}
          src={GearReverse}
        />
      )}
      <Header
        width={isBreakPosition ? 16 : 8}
        title="Mostly the Result of My Work"
        desciption="mostly the result of my work"
        // withDesc
      />
      <List
        style={{ marginTop: "24px" }}
        itemLayout="vertical"
        size="default"
        pagination={{
          onChange: (page) => {
            console.log(page);
          },
          pageSize: 3,
          simple: true,
        }}
        dataSource={listData}
        renderItem={(item) => (
          <List.Item
            key={item.title}
            actions={[
              <IconText
                icon={StarOutlined}
                text={item.star}
                key="list-vertical-star-o"
              />,
              <IconText
                icon={ForkOutlined}
                text={item.fork}
                key="list-vertical-like-o"
              />,
            ]}
            extra={
              <Image
                width={272}
                alt="Image"
                src={item.image}
                style={{
                  objectFit: "cover",
                  maxHeight: "200px",
                  overflow: "hidden",
                }}
              />
            }
          >
            <List.Item.Meta
              title={<a href={item.href}>{item.title}</a>}
              description={item.description}
            />
            {item.content}
          </List.Item>
        )}
      />
    </div>
  );
};

export default Portofolio;
